const debounce = require('lodash.debounce');

const inputSelector = 'input[name$="[ZipCode]"], input[name$="[HouseNumber]"], input[name$="[postal_code]"], input[name$="[street_number]"], input[name$="[street_number_postfix]"]';
const mapping       = {
    '[Street]':                'Street',
    '[street]':                'Street',
    '[HouseNumber]':           'HouseNumber',
    '[street_number]':         'HouseNumber',
    '[street_number_postfix]': 'HouseNumber',
    '[ZipCode]':               'ZipCode',
    '[postal_code]':           'ZipCode',
    '[City]':                  'City',
    '[city]':                  'City',
};

let xhrRequests = {};
let lastFetched = {};

/**
 * Process change for a single instance
 * @param {string} prefix
 */
const changeProcessor = function(prefix) {
    let inputs  = getAllInputsFor(prefix);
    let address = getAddressForInputs(inputs);

    // Check if it is useful to complete
    if (address.ZipCode === null || address.HouseNumber === null) {
        clearForInputs(inputs);
        return;
    }
    if (address.ZipCode.match(/^[0-9]{4}\s*[a-z]{2}$/i) === null || address.HouseNumber.match(/^\d+/) === null) {
        clearForInputs(inputs);
        return;
    }

    // No need to fetch previously fetched address
    if (lastFetched.hasOwnProperty(prefix) && JSON.stringify(lastFetched[prefix]) === JSON.stringify(address)) {
        setAddressForInputs(address, inputs);
        return;
    }

    // Abort any existing completions
    if (xhrRequests.hasOwnProperty(prefix)) {
        xhrRequests[prefix].abort();
    }

    // Load completion with AJAX
    xhrRequests[prefix] = $.ajax({
        type:       'POST',
        url:        window.app.urls.addressCompletion,
        data:       address,
        beforeSend: function() {
            loadForInputs(inputs);
        },
        success:    function(data) {
            if (data.hasOwnProperty('Result')) {
                setAddressForInputs(data.Result, inputs);
                lastFetched[prefix] = getAddressForInputs(inputs);
            } else if (!inputs.ZipCode[0].prop('readonly')) {
                clearForInputs(inputs);
            }
        },
        error:      function(jqXHR, textStatus) {
            // Only clear if the initial inputs are not readonly
            if (!inputs.ZipCode[0].prop('readonly')) {
                clearForInputs(inputs);
            }
        },
    });
};

/**
 * Get the prefix for all inputs based on a single input
 * @param $input
 * @returns string
 */
const getPrefixInForm = function($input) {
    return $input.attr('name').replace(/\[\w+\]$/, '');
};

/**
 * Get all current input for the form of a single input
 * @param {string} prefix
 * @return Object<string,Array<jQuery>>
 */
const getAllInputsFor = function(prefix) {
    let inputs = {};

    $('input[name^="' + prefix + '"]').each(function() {
        let $this = $(this);
        Object.keys(mapping).forEach(function(name) {
            let key = mapping[name];
            if ($this.is('[name$="' + name + '"]')) {
                if (inputs.hasOwnProperty(key)) {
                    inputs[key].push($this);
                } else {
                    inputs[key] = [$this];
                }
            }
        });
    });

    return inputs;
};

/**
 * Transform inputs to the respective address object
 * @param inputs
 * @return {{ZipCode: string, HouseNumber: string, Street: string, City: string}}
 */
const getAddressForInputs = function(inputs) {
    let address = {};
    Object.keys(inputs).forEach(function(property) {
        let value = [];
        inputs[property].forEach(function($elem) {
            value.push($elem.val());
        });
        address[property] = value.join(' ').trim();
        if (address[property].length === 0) {
            address[property] = null;
        }
    });
    return address;
};

/**
 * Set a complete address to inputs
 * @param {Object} address
 * @param {Object<string,Array<jQuery>>} inputs
 */
const setAddressForInputs = function(address, inputs) {
    Object.keys(inputs).forEach(function(property) {
        let inputElements = inputs[property];

        // Split street number and postfix to both inputs
        if (property === 'HouseNumber' && inputElements.length > 1) {
            let splitNumber = address[property].split(' ');
            inputElements[0].val(splitNumber[0]);
            inputElements[1].val(splitNumber[1]);
            return;
        }

        // Regular input setting
        inputElements[0].val(address[property]);
    });

    // Set autocompleted city and street to read only
    inputs.City.forEach(function($elem) {
        $elem.prop('readonly', true);
        $elem.closest('.form-group').removeClass('loading');
    });
    inputs.Street.forEach(function($elem) {
        $elem.prop('readonly', true);
        $elem.closest('.form-group').removeClass('loading');
    });
};

/**
 * Clear address completion for inputs
 *
 * @param {Object<string,Array<jQuery>>} inputs
 * @param {boolean} [emptyValues] Empty the values of the inputs too
 */
const clearForInputs = function(inputs, emptyValues) {
    emptyValues = emptyValues === undefined ? false : emptyValues;

    inputs.City.forEach(function($elem) {
        $elem.prop('readonly', false);
        $elem.closest('.form-group').removeClass('loading');
        if (emptyValues) {
            $elem.val('');
        }
    });
    inputs.Street.forEach(function($elem) {
        $elem.prop('readonly', false);
        $elem.closest('.form-group').removeClass('loading');
        if (emptyValues) {
            $elem.val('');
        }
    });
};

/**
 * Set loading state for inputs
 *
 * @param {Object<string,Array<jQuery>>} inputs
 */
const loadForInputs = function(inputs) {
    inputs.City.forEach(function($elem) {
        $elem.prop('readonly', true);
        $elem.closest('.form-group').addClass('loading');
    });
    inputs.Street.forEach(function($elem) {
        $elem.prop('readonly', true);
        $elem.closest('.form-group').addClass('loading');
    });
};

/**
 * Initialize a single container
 * @param {jQuery} [$container] Explicit container to initialize for, defaults to entire body
 */
export default ($container) => {
    let prefixes = [];
    $(inputSelector, $container).each(function() {
        let prefix = getPrefixInForm($(this));
        if (prefixes.indexOf(prefix) > -1) {
            return;
        }
        prefixes.push(prefix);
        $('input[name^="' + prefix + '"]', $container).on('keyup change', debounce(function() {
            if ($(this).is(inputSelector)) {
                changeProcessor(prefix);
            }
        }, 500));
    });
    $(inputSelector, $container).trigger('change');

    // Catch auto-fill with street number in street input
    $('input[name$="[Street]"], input[name$="[street]"]', $container).on('keyup change input blur', debounce(function() {
        if ($(this).prop('readonly')) {
            return;
        }
        let street  = $(this).val();
        let matched = street.match(/(.+)\s(\d+)\s?(.*)$/);
        if (matched !== null) {
            let inputs = getAllInputsFor(getPrefixInForm($(this)));
            inputs.HouseNumber.forEach(function($elem) {
                if ($elem.is('[name$="[street_number_postfix]"]')) {
                    $elem.val(matched[3]);
                } else if ($elem.is('[name$="[street_number]"]')) {
                    $elem.val(matched[2]);
                } else {
                    $elem.val(matched[2] + matched[3]);
                }
            });
            inputs.Street.forEach(function($elem) {
                $elem.val(matched[1]);
            });

            // Trigger a change for auto-complete
            inputs.ZipCode[0].trigger('change');
        }
    }, 150));
}
